import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"
import _imports_0 from '@/assets/loginRegister/notice.png'
import _imports_1 from '@/assets/deposit/deposit_bonus.png'


const _hoisted_1 = { class: "deposit_container" }
const _hoisted_2 = { class: "channel_text" }
const _hoisted_3 = { class: "channel_list" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "bonus_select" }
const _hoisted_7 = { class: "deposit_notice" }
const _hoisted_8 = { class: "sub_container" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "input_field" }
const _hoisted_11 = { class: "right-wrapper" }
const _hoisted_12 = {
  key: 0,
  class: "errorText"
}
const _hoisted_13 = { class: "btn_container" }
const _hoisted_14 = { key: 1 }

import { ref, watch } from 'vue';
import InputField from './components/inputField.vue';
import AmountCard from './components/amountCard.vue';
import { PayChannel } from '@/types/common';
import { formatCurrency } from '@/utils/commonFunction';
import { useUserStore } from '@/stores/user';
import { DepositData } from '@/view/deposit/supportScript';
import MainButton from '../components/common/mainButton.vue';
import CustomHeader from '../components/common/customHeader.vue';
import { useRouter } from 'vue-router';
import ErcCard from '@/themes/themeOne/deposit/components/ercCard.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'depositView',
  props: {
    dataSet: {}
  },
  emits: ['selectChannel', 'updateSelecTopup', 'updateSelectedAmount', 'updateCpfID', 'selectAmountCard', 'confirmDeposit'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const selecTopup = ref(props.dataSet.selecTopup)
const selectedAmount = ref(props.dataSet.selectedAmount)
const cpfID = ref(props.dataSet.cpfID)
const userStore = useUserStore()
const router = useRouter()
const showErc = ref(false)
const emit = __emit
const selectChannel = (item: PayChannel) => {
    emit('selectChannel', item)
}
watch(selecTopup, (val) => {
    emit('updateSelecTopup', val)
})
watch(selectedAmount, (val) => {
    emit('updateSelectedAmount', val)
})
watch(cpfID, (val) => {
    emit('updateCpfID', val)
})
watch(() => props.dataSet, (newVal) => {
    selectedAmount.value = newVal.selectedAmount
}, { deep: true, immediate: true })

const selectAmountCard = (select: any) => {
    selectedAmount.value = select.fillValue
    emit('selectAmountCard', select)
}
const confirmDeposit = () => {
    emit('confirmDeposit')
}
const onClear = () => {
    cpfID.value = ''
}
const backNavigate = () => {
    userStore.setTakeFirstDeposit(false)
    router.go(-1)
}

return (_ctx: any,_cache: any) => {
  const _component_van_checkbox = _resolveComponent("van-checkbox")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CustomHeader, {
      text: _ctx.$t('common.deposite'),
      "is-popup-close-back-icon": true,
      onClosePopup: backNavigate
    }, null, 8, ["text"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('common.paymentChannel')) + "：", 1),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSet.channelList, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["channel_card", _ctx.dataSet.activeChannel.id == item.id ? 'active_channel' : '']),
            key: item.name,
            onClick: ($event: any) => (selectChannel(item))
          }, _toDisplayString(item.name), 11, _hoisted_4))
        }), 128))
      ]),
      (!showErc.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "line" }, null, -1)),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_van_checkbox, {
                modelValue: selecTopup.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selecTopup).value = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('deposit.promotions')), 1)
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _cache[3] || (_cache[3] = _createElementVNode("img", {
                src: _imports_0,
                alt: ""
              }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('deposit.bonuseRedeem')) + " " + _toDisplayString(_ctx.dataSet.turnOverValue) + "x " + _toDisplayString(_ctx.$t('deposit.invoicing')), 1)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(InputField, {
                modelValue: selectedAmount.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedAmount).value = $event)),
                labelText: _ctx.$t('deposit.valueLabel') + ' (' + _ctx.dataSet.min_amount + ' ~ ' + _ctx.dataSet.max_amount + ')',
                isTopupVisible: selecTopup.value,
                giftAmount: _ctx.dataSet.giftAmount
              }, null, 8, ["modelValue", "labelText", "isTopupVisible", "giftAmount"]),
              (_ctx.dataSet.activeChannel.name == 'uupay' || _ctx.dataSet.activeChannel.name == 'qqpay')
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "inputLabel" }, "CPF ID", -1)),
                      _createVNode(_component_van_field, {
                        modelValue: cpfID.value,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((cpfID).value = $event)),
                        type: "number",
                        placeholder: _ctx.$t('withdraw.cpfIdPlaceholder')
                      }, {
                        "right-icon": _withCtx(() => [
                          _createElementVNode("div", _hoisted_11, [
                            (cpfID.value)
                              ? (_openBlock(), _createBlock(_component_van_icon, {
                                  key: 0,
                                  name: "clear",
                                  class: "custom-clear",
                                  onClick: _withModifiers(onClear, ["stop"])
                                }))
                              : _createCommentVNode("", true),
                            _createVNode(_component_van_icon, { name: "credit-pay" })
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    (_ctx.dataSet.showCPFIdError)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.$t('withdraw.cpfErrorText')), 1))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_van_row, { class: "amount_card_list" }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSet.amountList, (item) => {
                    return (_openBlock(), _createBlock(_component_van_col, {
                      span: "8",
                      key: item.fillValue,
                      style: {"padding":"5px"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(AmountCard, {
                          amount: item.fillValue,
                          isActiveAmount: _ctx.dataSet.selectedAmount == item.fillValue,
                          giftRatio: item.giftRatio,
                          isTopupVisible: selecTopup.value,
                          onHandleCardClick: ($event: any) => (selectAmountCard(item))
                        }, null, 8, ["amount", "isActiveAmount", "giftRatio", "isTopupVisible", "onHandleCardClick"])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }),
              (selecTopup.value)
                ? (_openBlock(), _createBlock(_component_van_row, {
                    key: 1,
                    class: "note_text"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_van_col, { span: "4" }, {
                        default: _withCtx(() => _cache[5] || (_cache[5] = [
                          _createElementVNode("img", {
                            src: _imports_1,
                            alt: ""
                          }, null, -1)
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_van_col, { span: "20" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('common.deposite')) + " R$ " + _toDisplayString(_unref(formatCurrency)(selectedAmount.value)) + " " + _toDisplayString(_ctx.$t('deposit.receive')) + " R$ " + _toDisplayString(_unref(formatCurrency)(_ctx.dataSet.giftAmount)) + " " + _toDisplayString(_ctx.$t('deposit.asaGift')) + ".", 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(MainButton, {
                title: _ctx.$t('common.deposite'),
                activeStatus: _ctx.dataSet.isFillField,
                onClick: confirmDeposit
              }, null, 8, ["title", "activeStatus"])
            ])
          ]))
        : _createCommentVNode("", true),
      (showErc.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createVNode(ErcCard)
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})